import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";
import { ViewShiftDetails } from "@/components/dialog/staff-manage/all-staff-dialog";
import { useState } from "react";

export function LetShiftTable({ allStaffSchedules, activeShiftType }) {
  const [openShiftDialog, setOpenShiftDialog] = useState(false);
  const [shiftDetails, setShiftDetails] = useState(null);
  const [shiftId, setShiftId] = useState(null);

  const onShiftDialog = (data) => {
    setShiftDetails(data.shift_schedule);
    setShiftId(data.id);
    setOpenShiftDialog(true);
  };

  const offshiftdialog = () => {
    setOpenShiftDialog(false);
  };

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[170px]">ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Weekly Working Day</TableHead>
            <TableHead>Monthly Hours</TableHead>
            <TableHead className="text-right">Time Sheet</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {allStaffSchedules.length > 0 ? (
            allStaffSchedules?.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">
                  {item?.id || "N/A"}
                </TableCell>
                <TableCell>{item?.name || "N/A"}</TableCell>
                <TableCell>{item?.phone || "N/A"}</TableCell>
                <TableCell>{item?.weekly_working_day || "N/A"}</TableCell>
                <TableCell>
                  {item?.monthly_hours !== undefined && item?.monthly_hours !== null && !isNaN(Number(item.monthly_hours))
                    ? Number(item.monthly_hours).toFixed(2)
                    : item?.monthly_hours || "N/A"}
                </TableCell>
                <TableCell className=" ">
                  <div className=" w-full h-full flex items-center justify-end pr-6 ">
                    <Eye
                      onClick={() => onShiftDialog(item)}
                      className=" cursor-pointer"
                      size={18}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6}>
                <div className="text-center text-gray-300 py-4">
                  No {activeShiftType === "weekly" ? "weekly" : "daily"} shift
                  available
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <ViewShiftDetails
        shiftId={shiftId}
        shifts={shiftDetails}
        isOpen={openShiftDialog}
        onClose={offshiftdialog}
      />
    </>
  );
}

export default LetShiftTable;
